<template>
  <div>
    <div class="table-box setTable">
        <loading :isShow="listLoading" />
          <Table :columns="columns" :data="tableData">
          <!-- 出单团队 -->
          <template slot-scope="{ row }" slot="confirmRightStatusIn">
            <span v-if="row.confirmRightStatus === 0">待单录</span>
            <span v-if="row.confirmRightStatus === 1">待质检</span>
            <span v-if="row.confirmRightStatus === 2">质检成功</span>
            <span v-if="row.confirmRightStatus === -1">质检失败</span>
            <Poptip trigger="hover" transfer-class-name="my-poptip left0" :transfer="true">
              <Icon style="color: #a8adb7; margin-left: 4px" type="md-help-circle" v-if="row.confirmRightStatus === -1 && row.qualityFailReason" />
              <div slot="content">
                <p>{{ row.qualityFailReason }}</p>
              </div>
            </Poptip>
          </template>
          <template slot-scope="{ row }" slot="status">
            <span v-if="row.status == '1'">已承保</span>
            <span v-if="row.status == '-1'">已退保</span>
            <span v-if="row.status == '0'">已终止</span>
          </template>
          <template slot-scope="{ row }" slot="action">
            <span class="table-btn" @click.stop="copyLink(row)" v-if="row.confirmRightStatus === 0 || row.confirmRightStatus === -1">复制确权链接</span>
            <span class="table-btn" @click.stop="$refs.detailModal.open(row)">详情</span>
          </template>
        </Table>
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
      </div>
      <!-- 线上保单详情  -->
    <detail-modal ref="detailModal"></detail-modal>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import { config } from './uninspectedPolicy.config.js';
import detailModal from '@/pages/orderManage/insuredOrder/components/detailModal';
export default {
  mixins: [pageTool, common, config],
  components: {detailModal},
  data(){
    return{
      pageSize: 5,
    }
  },
  mounted() {
    this.getList();
  },
  methods:{
    getList() {
      console.log(this.pageNum)
      this.listLoading = true;
      this.$http({
        url: '/buz/policy/read/list',
        type: 'post',
        data: {
          confirmRightStatusIn: ["0", "1", "-1"],
          confirmRightStatusNotNull:'1',
          pageNo: this.pageNum,
          pageSize: this.pageSize,
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    // 复制确权链接
    copyLink(item) {
      this.$http({
        url: '/buz/policy/queryConfirmRightUrl',
        type: 'GET',
        data: { policyNo: item.policyNo }
      }).then(res => {
        if (res.data) {
          this.$units.copyUrl(res.data);
        } else {
          this.$notice.msg('获取确权链接失败');
        }
      });
    },
  }

}
</script>

<style lang="scss" scoped>
.setTable{
  padding-bottom: 10px;
}
</style>